module.exports = __webpack_public_path__ + "static/img/ent-37.a17e741.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-37.jpg
// module id = EQq0
// module chunks = 51